<!--
 * @Author: Tina Huang
 * @Date: 2023-06-27 13:09:51
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-06-30 21:58:55
 * @Description: 
-->
<!--
 * @Author: Tina Huang
 * @Date: 2023-06-27 13:09:51
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-06-27 14:09:42
 * @Description: 
-->
<template>
  <div class="box">
    <div class="menu">
      <router-link :to="{ name: 'mwids' }">
        <div
          class="menu-item widgets"
          data-splitbee-event="To Widgets in mobile"
        >
          配置组件
        </div>
      </router-link>
      <router-link :to="{ name: 'mpicks' }">
        <div
          class="menu-item template"
          data-splitbee-event="To template in mobile"
        >
          拷贝模版
        </div>
      </router-link>
      <router-link :to="{ name: 'mpro' }">
        <div class="menu-item vip" data-splitbee-event="To VIP in mobile">
          永久会员
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      site_name: "Widverse · 汪汪汪世界",
      drawer: false,
      direction: "rtl",
      newUpdate: null,
      centerDialogVisible: false,
      // pathname: this.$route.name,
      // news_update:
    };
  },
  methods: {
    handleTip() {
      this.$message({
        message: "该模块正在加紧开放中……",
        center: true,
        type: "warning",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  position: sticky;
  .menu-item {
    flex: 0 0 100%;
    position: relative;
    width: 300px;
    margin: 40px auto;
    text-align: center;
    font-size: 32px;
    padding: 30px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0 30px 40px 40px;
    box-shadow: 0 10px 30px rgba(24, 32, 79, 0.15),
      inset 0 0 0 0.5px hsla(0, 0%, 100%, 0.1);
    &:after {
      background-image: linear-gradient(
        90deg,
        rgba(132, 143, 224, 30%),
        rgba(132, 143, 200, 30%) 51%,
        rgba(132, 143, 200, 10%)
      );
      border-radius: 0 40px 40px;
      content: "";
      font-size: 0;
      height: 100%;
      left: 0;
      position: absolute;
      right: 40px;
      top: 0;
      transform: skewY(5deg);
      transform-origin: left top 0;
      transition: 0.5s;
      z-index: -1;
    }
  }
}
.menu .template::after {
  background-image: linear-gradient(
    90deg,
    rgba(174, 87, 124, 30%),
    rgba(174, 87, 80, 30%) 51%,
    rgba(174, 87, 80, 10%)
  );
}
.menu .vip::after {
  background-image: linear-gradient(
    90deg,
    rgba(230, 162, 60, 30%),
    rgba(245, 218, 177, 30%) 51%,
    rgba(245, 218, 177, 10%)
  );
}
.footer {
  text-align: center;
  font-size: 12px;
  padding-top: 20px;
}
</style>
